import { render, staticRenderFns } from "./TableStatisticConfigComponents.vue?vue&type=template&id=cb8e8cd0"
import script from "./TableStatisticConfigComponents.vue?vue&type=script&lang=js"
export * from "./TableStatisticConfigComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports